// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.placeholder_article__9Bem0 {
  width: 18rem;
  display: flex;
  flex-flow: column;
  gap: 1rem;
}
.placeholder_article__9Bem0 > div {
  height: 1rem;
  border-radius: 16px;
}
.placeholder_article__9Bem0 .placeholder_image__wmV4s {
  height: 8rem;
}
.placeholder_loading__ZmnHC {
  background: linear-gradient(
    90deg,
    var(--placeholder-main),
    var(--placeholder-shadow),
    var(--placeholder-main)
  );
  background-size: 200%;
  border-1rem: 1rem;
  animation: placeholder_pulse__W-Avg 1s infinite alternate cubic-bezier(0.46, 0.03, 0.52, 0.96);
}
@media (prefers-reduced-motion) {
  .placeholder_loading__ZmnHC {
    animation: none;
  }
}
@keyframes placeholder_pulse__W-Avg {
  from {
    background-position-x: 100%;
  }
  to {
    background-position-x: 0%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/placeHolder/placeholder.module.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,aAAa;EACb,iBAAiB;EACjB,SAAS;AACX;AACA;EACE,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,YAAY;AACd;AACA;EACE;;;;;GAKC;EACD,qBAAqB;EACrB,iBAAiB;EACjB,8FAA2E;AAC7E;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE,2BAA2B;EAC7B;EACA;IACE,yBAAyB;EAC3B;AACF","sourcesContent":[".article {\n  width: 18rem;\n  display: flex;\n  flex-flow: column;\n  gap: 1rem;\n}\n.article > div {\n  height: 1rem;\n  border-radius: 16px;\n}\n.article .image {\n  height: 8rem;\n}\n.loading {\n  background: linear-gradient(\n    90deg,\n    var(--placeholder-main),\n    var(--placeholder-shadow),\n    var(--placeholder-main)\n  );\n  background-size: 200%;\n  border-1rem: 1rem;\n  animation: pulse 1s infinite alternate cubic-bezier(0.46, 0.03, 0.52, 0.96);\n}\n@media (prefers-reduced-motion) {\n  .loading {\n    animation: none;\n  }\n}\n@keyframes pulse {\n  from {\n    background-position-x: 100%;\n  }\n  to {\n    background-position-x: 0%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"article": `placeholder_article__9Bem0`,
	"image": `placeholder_image__wmV4s`,
	"loading": `placeholder_loading__ZmnHC`,
	"pulse": `placeholder_pulse__W-Avg`
};
export default ___CSS_LOADER_EXPORT___;
